













import { Component, Vue } from 'vue-property-decorator';
import Popup from '@/components/popups/Popup.vue';
import { namespace } from 'vuex-class';

const ui = namespace('UI');

const puzzle = namespace('Puzzle');

@Component({
  components: {
    Popup,
  },
})
export default class RevealPuzzlePopup extends Vue {
  @ui.Mutation
  private closePopup!: () => void;

  @puzzle.Action
  private revealPuzzle!: () => void;

  private reveal() {
    this.closePopup();
    this.revealPuzzle();
  }

  private cancel() {
    this.closePopup();
  }
}
